import React, {useState} from 'react'
import {Button, Form, Input, Modal} from "antd";
import {createBrand} from "../../services/serviceBrand";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const { TextArea } = Input

const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const BrandCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [loadings, setLoadings] = useState([])

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            name: list.brandName,
            code: list.brandCode,
            description: list.brandDescription
        }
        createBrand(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Modal
                open={show}
                closable={false}
                title={'Yeni Marka Ekle'}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            onClick={() => form.submit()}
                            loading={loadings[0]}
                    >Kaydet</Button>,
                    <Button  key={'CancelButton'} onClick={() => modalCloser()} >Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >

                    <Form.Item
                        label={'Marka Adı'}
                        name={'brandName'}
                        rules={[
                            {required: true, message: 'Marka Adı Alanı Boş Bırakılamaz'},
                            {min: 1, max: 300, message: 'Marka Adı En Az 5 En Fazla 300 Karakter Olmalı'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Marka Kodu'}
                        name={'brandCode'}
                        rules={[
                            {required: true, message: 'Marka Kodu Alanı Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Marka Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 20, message: 'Marka Kodu En Az 3 En Fazla 20 Karakter Olmalı'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Marka Açıklaması'}
                        name={'brandDescription'}
                        rules={[
                            {min: 1, max: 1000, message: 'Marka Açıklaması En az 1 En Fazla 1000 Karakter Olmalı'}
                        ]}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default BrandCreate